import { SortDescriptor } from '@progress/kendo-data-query';

export const actionRequiredFilters: { filters: any[]; sort: SortDescriptor[] }[] = [
  {
    filters: [],
    sort: [],
  },
  {
    filters: [
      {
        field: 'requesterInvoiceOverCreatorLimit',
        value: 'false',
        operator: 'eq',
      },
      {
        field: 'requesterInvoiceGlMismatch',
        value: 'false',
        operator: 'eq',
      },
      {
        field: 'requesterInvoiceContainsNewLineItem',
        value: 'false',
        operator: 'eq',
      },
      {
        field: 'requesterInvoiceItemQtyOverage',
        value: 'false',
        operator: 'eq',
      },
      {
        field: 'requesterInvoiceItemPriceOverage',
        value: 'false',
        operator: 'eq',
      },
      {
        field: 'requesterInvoiceOverPoDollarLimit',
        value: 'false',
        operator: 'eq',
      },
      {
        field: 'requesterInvoiceOverPoPercentLimit',
        value: 'false',
        operator: 'eq',
      },
    ],
    sort: [],
  },
  {
    filters: [
      {
        field: 'invoiceOverCreatorLimit',
        value: 'true',
        operator: 'eq',
      },
    ],
    sort: [],
  },
  {
    filters: [],
    sort: [],
  },
  {
    filters: [
      {
        field: 'invoiceInCurrentBudgetPeriod',
        value: 'false',
        operator: 'eq',
      },
    ],
    sort: [],
  },
  {
    filters: [
      {
        field: 'buyerNotes',
        operator: 'notisnullorempty',
      },
    ],
    sort: [],
  },
  {
    filters: [
      {
        field: 'totalCostAmt',
        value: '0',
        operator: 'gte',
      },
    ],
    sort: [],
  },
  {
    filters: [
      {
        field: 'totalCostAmt',
        value: '0',
        operator: 'lt',
      },
    ],
    sort: [],
  },
  {
    filters: [
      {
        field: 'percentRecvByQuantity',
        value: '100',
        operator: 'lt',
      },
    ],
    sort: [],
  },
  {
    filters: [
      {
        field: 'percentRecvByQuantity',
        value: '100',
        operator: 'gte',
      },
    ],
    sort: [],
  },
];
